import { CssBaseline } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { clearAuthToken, setAuthToken } from './auth';
import {
  Initialize,
  RootProvider,
  useVersionExpectations,
  VersionUpdateView,
} from './utils';

export const App = () => {
  const [sessionValidationKey, setSessionValidationKey] = useState(0);
  const [isValidSession, setIsValidSession] = useState(false);
  const queryClient = useQueryClient();

  const versionExpectation = useVersionExpectations();

  const invalidateSession = async () => {
    await clearAuthToken();
    setIsValidSession(false);
    queryClient.clear();
  };

  const setSession = async (sessionToken: string) => {
    await setAuthToken(sessionToken);
  };

  if (versionExpectation.state === 'LOADING') {
    // Since version expectation relies on local storage and
    // on providers being initialized by now this is a very
    // quick state.
    return undefined;
  }

  if (versionExpectation.state !== 'SATISFIED') {
    return (
      <>
        <CssBaseline />
        <VersionUpdateView
          state={versionExpectation.state}
          onIgnoreUpdate={versionExpectation.onIgnoreUpdate}
        />
      </>
    );
  }

  return (
    <RootProvider
      retryVerifySession={() => setSessionValidationKey(Date.now())}
      setSession={setSession}
      isValidSession={isValidSession}
      removeLocalSession={invalidateSession}
    >
      <CssBaseline />
      <Initialize
        sessionValidationKey={sessionValidationKey}
        isValidSession={isValidSession}
        onValidSessionChanged={setIsValidSession}
      />
    </RootProvider>
  );
};
